<template>
  <div class="dropdown-trigger">
    <slot></slot>
  </div>
</template>
